import { useTheme } from "@emotion/react";
import { Divider } from "@fullscript/aviary-web";

import FullscriptLogoGreenLeafPigeonTextSVGComponent from "@shared/assets/logo/FullscriptLogoGreenLeafPigeonText";
import FullscriptLogoWhiteTextGreenLeafSVGComponent from "@shared/assets/logo/FullscriptLogoWhiteTextGreenLeaf";

import { StoreLogo } from "../StoreLogo/StoreLogo";

import * as styles from "./StorefrontWelcomeLogo.styles";

interface Props {
  organizationLogo?: string;
  storeName?: string;
}

const StorefrontWelcomeLogo = ({ organizationLogo, storeName }: Props) => {
  const theme = useTheme();

  const fsLogo = () => {
    const logoContainer = organizationLogo ? styles.svgContainer : styles.soloLogoContainer;
    if (theme.theme === "dark") {
      return <FullscriptLogoWhiteTextGreenLeafSVGComponent css={logoContainer} />;
    }

    return <FullscriptLogoGreenLeafPigeonTextSVGComponent css={logoContainer} />;
  };

  return (
    <div css={styles.container}>
      {!!organizationLogo && (
        <StoreLogo storeLogo={organizationLogo ?? ""} storeName={storeName ?? ""} />
      )}
      {!!organizationLogo && <Divider />}
      {fsLogo()}
    </div>
  );
};

export { StorefrontWelcomeLogo };
